<template>
  <b-row class="border-right d-flex align-items-center">
    <b-col>
      <b-form-group
        label="Arama"
        label-for="keywords"
      >
        <b-input-group>
          <b-form-input
            id="keywords"
            v-model="filterParams.keywords"
            placeholder="Proje Adı, Proje Kodu..."
            @keydown.enter="getDataList"
          />
          <b-input-group-append>
            <b-button
              variant="danger"
              @click="getDataList"
            >
              <FeatherIcon icon="SearchIcon" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BButton, BFormInput, BFormGroup, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'

export default {
  name: 'FilterCard',
  components: {
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
  },
  props: {
    getDataList: {
      type: Function,
      required: true,
    },
  },
  computed: {
    filterParams() {
      return this.$store.getters['projects/filterParams']
    },
  },
}
</script>
